import { render, staticRenderFns } from "./general-info-edit-tab.vue?vue&type=template&id=0005d7c4&scoped=true"
import script from "./general-info-edit-tab.vue?vue&type=script&lang=js"
export * from "./general-info-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./general-info-edit-tab.vue?vue&type=style&index=0&id=0005d7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0005d7c4",
  null
  
)

export default component.exports